import type { Database } from 'sql.js';
import {
  queryOne,
  rowFirstKeyColumn as rowCol,
  type SqlJsBind,
  sqlPositiveIntId,
} from '@core/infrastructure/driven/sqljs/sqljsSqlitePrimitives.ts';

type SqlBind = SqlJsBind;

/**
 * Resolve guardian row tied to PEP: FK path first; if FK missing/deleted yet acta flagged guardian,
 * fall back to newest `acudientes` row for same participant (mirrors persistence rules).
 */
export function resolveAcudienteRow(
  db: Database,
  pep: Record<string, SqlBind>,
): Record<string, SqlBind> | null {
  const esAcud = Number(rowCol(pep, 'es_acudiente', 'ES_ACUDIENTE') ?? 0) === 1;
  if (!esAcud) return null;

  const aid = sqlPositiveIntId(rowCol(pep, 'acudiente_id', 'ACUDIENTE_ID'));
  if (aid != null) {
    const row = queryOne(db, 'SELECT * FROM acudientes WHERE id = ?', [aid]);
    if (row) return row;
  }

  const pid = sqlPositiveIntId(rowCol(pep, 'participante_id', 'PARTICIPANTE_ID'));
  if (pid == null) return null;
  return queryOne(db, 'SELECT * FROM acudientes WHERE participante_id = ? ORDER BY id DESC LIMIT 1', [
    pid,
  ]);
}
